import axios from "axios";

export default () => {
  return axios.create({
    baseURL: process.env.NODE_ENV === "production"
    ? `${process.env.VUE_APP_JTI_CMT_CREDIT_REGISTRATION_SERVICE}/${process.env.VUE_APP_CREDIT_REGISTRATION_PROXY}` 
    : `${process.env.VUE_APP_JTI_CMT_CREDIT_REGISTRATION_SERVICE}:${process.env.VUE_APP_JTI_CMT_CREDIT_REGISTRATION_SERVICE_PORT}`,
    headers: {
      "Content-Type": `application/json`,
      Authorization: `Bearer ${process.env.VUE_APP_JTI_CMT_CREDIT_REGISTRATION_SERVICE_TOKEN}`,
    },
  });
};
